import { Component, Injector, Input } from '@angular/core';
import { Events } from 'ionic-angular';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'linesvg', 
  templateUrl: 'linesvg.html',
}) 

export class LineSvgComponent{

  @Input('percent') percent:number; 
  @Input('width') width:number; 
  @Input('startcolor') startcolor:string; 
  @Input('endcolor') endcolor:string; 
  @Input('strokecolor') strokecolor:string;
  percentuale:any;
  lunghezza:any;
  crand:any;
  constructor(public events: Events) {
  }
  update_output(){
  //  this.events.publish('aperta', this.domanda, this.risp);
  }
  ngOnInit(){
    //var l = this.width/100 * this.percent;
    // this.lunghezza = "M10,10L"+this.width+",10";
    // this.percentuale = "M10,10L"+l+",11";
    //////////this.lunghezza = "M10,10L"+this.width+",10"; 
    this.crand = this.guid();
    this.lunghezza = "M10,0L12,0";
    //this.percentuale = "M10,0L"+l+",0";
    //d="M1,0L99,0"
    if(this.percent < 12)
      this.percentuale = 12;
    else
      this.percentuale = 290/100*this.percent;
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  guid() {
  return this.s4() + this.s4() + this.s4()  + this.s4();
  }
}



// WEBPACK FOOTER //
// ./src/pages/component/linesvg.ts